import { useNavigate } from "react-router-dom";
import trioImage from "@/assets/trio.jpg";

const AboutSection = () => {
  const navigate = useNavigate();
  return (
    <section className="py-8 md:py-12 px-4">
      <div className="container mx-auto max-w-5xl">
        <div className="flex flex-col md:flex-row gap-6 md:gap-10 items-center">
          {/* Text side */}
          <div className="flex-1 order-2 md:order-1 text-center md:text-left">
            <h2
              onClick={() => navigate("/about")}
              className="text-3xl md:text-4xl font-bold text-foreground mb-4 cursor-pointer hover:text-primary transition-colors duration-200"
            >
              About Us
            </h2>
            <p className="text-muted-foreground leading-relaxed">
              GamDucks started with Jason (right) and Casper (left), two guys who met through the iGaming industry and decided to build something of their own. After wrapping up a project together, a spontaneous casino visit and a big winning night was all it took. Joey (center) joined as the channel grew, and what started as a two-man operation became a tight-knit community.
            </p>
          </div>

          {/* Image side */}
          <div className="flex-1 order-1 md:order-2">
            <div className="relative rounded-xl overflow-hidden border border-primary/20 shadow-lg shadow-primary/5">
              <img
                src={trioImage}
                alt="GamDucks team - Joey, Casper, and Jason"
                className="w-full h-auto object-cover aspect-[4/3]"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
